/** Situações do Item */
export interface ItemSituacao {
    id: number;
    nome: string;
}

export const itemSituacaoAtivo: ItemSituacao = {id: 1, nome: 'Ativo'};
export const itemSituacaoInativo: ItemSituacao = {id: 2, nome: 'Inativo'};

export const itemSituacoes: ItemSituacao[] = [
    itemSituacaoAtivo,
    itemSituacaoInativo
];

/** Verifica se a situação informadaé igual a Ativo */
export function isSituacaoAtivo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === itemSituacaoAtivo.id;
}

/** Verifica se a situação informadaé igual a Inativo */
export function isSituacaoInativo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === itemSituacaoInativo.id;
}
